'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.default = Modal;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./modal.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * WH Modal Component.
 * @param {ModalProps} props The new component properties.
 * @returns {React$Element<any>} HTML markup for the component
 */
function Modal(props) {
    var _cx;

    var _props$className = props.className,
        className = _props$className === undefined ? '' : _props$className,
        _props$overlayClassNa = props.overlayClassName,
        overlayClassName = _props$overlayClassNa === undefined ? '' : _props$overlayClassNa,
        _props$isOpen = props.isOpen,
        isOpen = _props$isOpen === undefined ? false : _props$isOpen,
        _props$type = props.type,
        type = _props$type === undefined ? 'primary' : _props$type,
        _props$size = props.size,
        size = _props$size === undefined ? 'small' : _props$size,
        _props$onRequestClose = props.onRequestClose,
        onRequestClose = _props$onRequestClose === undefined ? function (f) {
        return f;
    } : _props$onRequestClose,
        contentLabel = props.contentLabel,
        _props$id = props.id,
        id = _props$id === undefined ? '' : _props$id,
        _props$parentSelector = props.parentSelector,
        parentSelector = _props$parentSelector === undefined ? function () {
        return document.querySelector('body');
    } : _props$parentSelector;


    var classNames = (0, _classnames2.default)((_cx = {
        'sb-modal': true
    }, (0, _defineProperty3.default)(_cx, 'sb-modal--' + size, size), (0, _defineProperty3.default)(_cx, 'sb-modal--' + type, type), (0, _defineProperty3.default)(_cx, '' + className, className), _cx));

    var overlayClassNames = (0, _classnames2.default)((0, _defineProperty3.default)({
        'sb-modal-overlay': true
    }, '' + overlayClassName, overlayClassName));

    return (0, _jsx3.default)(_reactModal2.default, {
        isOpen: isOpen,
        className: classNames,
        overlayClassName: overlayClassNames,
        onRequestClose: onRequestClose,
        contentLabel: contentLabel,
        id: id,
        parentSelector: parentSelector
    }, void 0, props.children);
}
// css
//# sourceMappingURL=Modal.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/modal/Modal.js
// module id = 580
// module chunks = 0